import React from 'react';
import { Helmet } from 'react-helmet-async';

import { Event } from 'app/shared/typings';

export const FacebookMetaMicrodataTags = ({
  event,
  isOutOfStock,
}: {
  event: Event;
  isOutOfStock: boolean;
}) => {
  const eventPrice = event.price ? event.price.toString() : '0';
  const currency = event.city?.currencyCode?.toUpperCase();
  const availability = isOutOfStock ? 'out of stock' : 'in stock';

  const {
    onPresale,
    attendeeFlow,
    eventOrganizedAs,
    city: {
      country: { countryCode },
    },
  } = event;

  const isOAndOCountry =
    countryCode === 'US' || countryCode === 'CA' || countryCode === 'GB';

  if (
    onPresale ||
    attendeeFlow !== 'buy' ||
    !isOAndOCountry ||
    (eventOrganizedAs !== 'o_and_o' && eventOrganizedAs !== 'producer')
  ) {
    return null;
  }

  return (
    <Helmet prioritizeSeoTags>
      <meta property="og:id" content={event.id} />
      <meta property="product:retailer_item_id" content={event.id} />
      <meta property="product:price:amount" content={eventPrice} />
      <meta property="product:brand" content="Sofar Sounds" />
      <meta property="product:availability" content={availability} />
      <meta property="product:price:currency" content={currency} />
      <meta property="product:category" content="499969" />
    </Helmet>
  );
};

export default FacebookMetaMicrodataTags;
